import classNames from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import Icon, { Icons } from '../Icon/Icon';
import ListItem from '../ListItem/ListItem';
import './Dropdown.scss';

const CHEVRON_SIZE = 24;

const Dropdown = ({ triggerTitle, triggerProps, content, className }) => {
	const [open, setOpen] = useState(false);

	return (
		<div className={classNames('Dropdown', className, { open: open })}>
			<ListItem
				{...triggerProps}
				className='Dropdown-btn'
				onSelect={() => setOpen(prev => !prev)}
				title={triggerTitle}
				trailing={[
					triggerProps?.trailing,
					<Icon className='chevron' type={Icons['ARROW_CHEVRON']} width={CHEVRON_SIZE} height={CHEVRON_SIZE} />,
				]}
			/>

			<AnimatePresence>
				{open && (
					<motion.div
						className='Dropdown-body'
						initial={{ height: 0, opacity: 0 }}
						animate={{ height: 'auto', opacity: 1 }}
						exit={{ height: 0, opacity: 0 }}
						transition={{ duration: 0.3 }}
					>
						{content(open, setOpen)}
					</motion.div>
				)}
			</AnimatePresence>
		</div>
	);
};

Dropdown.propTypes = {
	className: PropTypes.string,
	triggerTitle: PropTypes.string,
	triggerProps: PropTypes.object,
	content: PropTypes.func,
};

export default Dropdown;
